module.exports = __webpack_public_path__ + "img/icon-check-square.2b97c996.svg";